import Qs from 'query-string';

const parseQueryString = (search) => {
  return Qs.parse(search);
};

export const converter = {
  parseQueryString,
};
